import React from 'react';
import '../../css/cart.css'

function likeList_empty() {
    return(
        <div className="empty-cart">
            <p>하트를 눌러 찜 리스트를 채워주세요!</p>
        </div>
    )
}

export default likeList_empty;